<template>
  <div
    v-show="showBuyRecommResult"
    :class="['dialog', showRatingDialog ? 'dialog-props-score' : '', 'dialog--recommend dialog--recommend--style']"
  >
    <div class="dialog-bg"></div>
    <div
      :class="[
        'dialog-container',
        currentProp && currentProp.disableRate ? 'dialog-container--style' : '',
        showRatingDialog ? 'lol-effect-eat props-score' : ''
      ]"
    >
      <div :class="[showRatingDialog ? '' : 'header']">
        <div class="header-t">
          <p>{{ showRatingDialog ? "道具评分" : "好友种草" }}</p>
          <span class="close" @click="closePropRecomm"></span>
        </div>
        <div v-if="!showRatingDialog" class="header-b">
          <i>好友可以在商品详情页看到您的种草~</i>
        </div>
      </div>
      <!-- logo -->
      <div class="bg-logo"></div>
      <div :class="[showRatingDialog ? '' : 'list-con']">
        <!-- 道具 -->
        <div v-if="!showRatingDialog" class="exhibit-goods">
          <div class="exhibit-goods-l">
            <img :src="(currentProp && currentProp.allIcon && currentProp.allIcon[0]) || ''" alt="" />
            <p>{{ currentProp && currentProp.name }}</p>
          </div>
          <div class="exhibit-goods-r"></div>
        </div>
        <!-- 种草方式 -->
        <div v-if="currentProp && !currentProp.disableRate && !showRatingDialog" class="plant-way">
          <!-- 增加种草标签 -->
          <div v-if="dimensionList.length > 0" class="plant-label">
            <div class="plant-label-title">
              <span></span>
              <p>打高分给好友种草（非必选）</p>
              <span></span>
            </div>
            <div class="plant-way--star">
              <div v-for="(dimension, i) in dimensionList" :key="'dimensionList' + i" class="item">
                {{ dimension.desc }}
                <span :class="[dimension.score == 4 ? 'active' : '']" @click="selectRateScore(i, 4)">四星</span>
                <span :class="[dimension.score == 5 ? 'active' : '']" @click="selectRateScore(i, 5)">五星</span>
              </div>
            </div>
          </div>
          <!-- 增加种草标签 -->
          <div v-if="recommTags && recommTags.length > 0" class="plant-label">
            <div class="plant-label-title">
              <span></span>
              <p>选择我的种草标签（非必选）</p>
              <span></span>
            </div>
            <div class="plant-label-con plant-label-con--style">
              <div class="label-list">
                <ul>
                  <template v-for="(tag, index) in recommTags">
                    <li
                      :key="'recommTags' + index"
                      :class="[selectedTags.indexOf(tag) > -1 ? 'active' : '']"
                      @click.stop.prevent="selectTag(tag)"
                    >
                      {{ tag }}
                    </li>
                  </template>
                </ul>
              </div>
              <div class="arr-btn">
                <span></span>
              </div>
            </div>
          </div>
        </div>
        <div v-if="showRatingDialog">
          <div class="plant-label-title">
            <span></span>
            <p>来给您刚刚购买的商品打分</p>
            <span></span>
          </div>
          <div class="eva-right">
            <div v-for="(item, index) in dimensionList" :key="index" class="star-item">
              <p>{{ item.desc }}</p>
              <ul>
                <li
                  v-for="(star, key) in [1, 2, 3, 4, 5]"
                  :key="key"
                  :data-star="star"
                  :data-index="index"
                  :class="item.score * 1 >= star ? '' : 'gray-star'"
                  @click.stop.prevent="selectRateScore(index, star)"
                ></li>
              </ul>
              <span>{{ STAR_REMARK[Math.round(dimensionList[index].score * 1)] }}</span>
            </div>

            <!-- 评分按钮 -->
            <div v-if="showRatingDialog" class="props-score-btn">
              <p @click="toggleRate">想给好友种草<span></span></p>
              <div @click="submitRate">提交评分</div>
            </div>
          </div>
        </div>
        <!-- 种草按钮 -->
        <div v-if="!showRatingDialog" class="props-score-btn">
          <p v-if="currentProp && !currentProp.disableRate && dimensionList.length > 0" @click="toggleRate">
            不想种草，只想评分<span></span>
          </p>
          <div @click="recommBuyedProps">给好友种草</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { reactive, toRefs, computed, onBeforeMount, onUnmounted } from "@vue/composition-api"
import { FriendRecommendApi } from "../../../api/friendRecomm"
import { StarRatingApi } from "../../../api/starRating"
import * as reportDict from "@constants/report-dictonary"
import { STAR_REMARK } from "../../../store/enums"
import { uniqueArr } from "@utils/helper"
import { getParam } from "@utils/url"

export default {
  props: ["currentItem", "currentProp", "userRecommInfo", "gameid", "behavior", "goodsId"],

  setup(props, { root, emit }) {
    const state = reactive({
      cgiInfo: null,
      offerId: props.currentItem.ams.offerid,
      subjectId: props.currentProp?.itemExtend?.AMSID,
      subjectType: props.currentProp?.subjectType,
      showBuyRecommResult: true,
      dimensionList: [],
      showRatingDialog: false,
      recommTags: [],
      selectedTags: [],
      // 大区的参数
      zoneParams: computed(() => {
        if (props.gameid) {
          let [area, roleid, , partition] = [...props.gameid.split("_")]
          return {
            area,
            game_platform_id: root.$store.getters.userAgent.iOS ? 0 : 1,
            partition,
            roleid
          }
        }

        return {}
      })
    })

    let { pf, sandbox } = root.$store.state

    let PromptWithIcon = null
    const scoreFactor = 2
    const SYSTEM_BUSY = "系统繁忙，请稍后再试"

    let friendRecommObj = new FriendRecommendApi({
      pf,
      sandbox,
      sessionObj: root.$store.getters.sessionObj,
      offerId: state.offerId
    })

    let starRatingObj = new StarRatingApi({
      pf,
      sandbox,
      sessionObj: root.$store.getters.sessionObj,
      offerId: state.offerId
    })

    onBeforeMount(async () => {
      // 可评分【非王者公众号入口】
      // disableRate--王者官方商城入口，不能评分+推荐语
      // onlyDisableRate--商店入口，不能评分，可以推荐语
      if (props.currentProp && !props.currentProp?.disableRate && !props.currentProp?.onlyDisableRate) {
        root.$store.dispatch("setLoadingStart")

        // 查询频分维度
        state.cgiInfo = await starRatingObj.queryUserStarRating({
          subject_id: state.subjectId,
          subject_type: state.subjectType,
          score_factor: scoreFactor
        })

        root.$store.dispatch("setLoadingEnd")

        let dimensionRes = getCgiRes(state.cgiInfo)
        if (dimensionRes) {
          // 初始化评分list，分数默认为空 ——改为保留
          state.dimensionList = dimensionRes?.dimension_score.map(item => {
            return {
              ...item,
              score: Math.round((item.score * 1) / scoreFactor)
            }
          })
        }
      }

      if (props.currentProp && !props.currentProp?.disableRate) {
        initRecommTags()
        initSentence()
      }

      root.$store.dispatch("reportUserAction", {
        iformat: reportDict.PAGE_VIEW.RESULT_FRIEND_RECOMMEND
      })
    })

    onUnmounted(() => {
      try {
        PromptWithIcon?.hide && PromptWithIcon.hide()
      } catch (error) {
        console.log(error)
      }
    })

    const getCgiRes = res => {
      if (res.ret == 0 && res.data) {
        return res.data
      } else {
        return null
      }
    }

    /**
     * 初始化业务层级和道具层级配置的推荐语
     */
    const initRecommTags = () => {
      if (props.currentItem?.friendRecommSentence) {
        state.recommTags = props.currentItem?.friendRecommSentence.split("$$")
      }
      if (props.currentProp?.goodsExtend?.RecommSentence) {
        state.recommTags = [...props.currentProp?.goodsExtend?.RecommSentence?.split("$$"), ...state.recommTags]
      }
      //去重
      state.recommTags = uniqueArr(state.recommTags)
    }

    /**
     * 初始化选中推荐标签
     */
    const initSentence = () => {
      if (props.userRecommInfo?.sentence) {
        try {
          let existedTags = decodeURIComponent(props.userRecommInfo?.sentence).split("$$")
          existedTags.map(tag => {
            if (state.recommTags.indexOf(tag) > -1) {
              state.selectedTags.push(tag)
            }
          })
        } catch (error) {
          console.log("sentence error")
        }
      }
    }

    /**
     * 用户选择标签
     */
    const selectTag = tag => {
      if (state.selectedTags.indexOf(tag) === -1) {
        state.selectedTags.push(tag)

        root.$store.dispatch("reportUserAction", {
          iformat: reportDict.CLICK.RESULT_FRIEND_RECOMMEND_COMMENTS
        })
      } else {
        state.selectedTags.splice(state.selectedTags.indexOf(tag), 1)
      }
    }

    const selectRateScore = (dimensionIndex, score) => {
      state.dimensionList[dimensionIndex].score = score

      root.$store.dispatch("reportUserAction", {
        iformat: state.showRatingDialog
          ? reportDict.CLICK.RESULT_FRIEND_RECOMMEND_RATE_STAR
          : reportDict.CLICK.RESULT_FRIEND_RECOMMEND_STAR,
        resultInfo: getReportResultInfo()
      })
    }

    /**
     * 种草道具
     */
    const recommBuyedProps = async () => {
      // 单纯评分，需要评分完整才可以提交
      if (state.dimensionList?.length > 0) {
        let ratedDimension = state.dimensionList.filter(dimension => {
          return dimension.score > 0
        })
        if (ratedDimension.length > 0 && ratedDimension.length < state.dimensionList.length) {
          // 阻止评分，提示用户补充完整
          root.$store.dispatch("setToastMsg", "您的打分不完整哦，赶紧去补全吧~")
          return
        }
        // 提交评分
        if (ratedDimension.length == state.dimensionList.length) {
          handleRateProps({ recomm: true })
        }
      }

      // 种草
      root.$store.dispatch("setLoadingStart")
      let result = await handleBuyRecomm(state.subjectId, props.behavior)

      root.$store.dispatch("setLoadingEnd")

      if (result?.ret !== 0) {
        let errMsg = result.err_code ? SYSTEM_BUSY : result?.msg ? result.msg : SYSTEM_BUSY
        root.$store.dispatch("setToastMsg", errMsg)
      } else {
        closePropRecomm()
        PromptWithIcon = root.$CallPromptWithIcon({
          title: "好友种草",
          iconStatus: true,
          mainMsg: "种草成功！",
          subMsg: "好友可通过商品详情页看到您的种草~",
          cancelBtnInfo: {
            btnText: "去看看我的种草",
            callback() {
              if (
                (root.$store.getters.userAgent.weixinminiprogram || root.$store.getters.fromMini) &&
                getParam("action") == "propMiniResult"
              ) {
                let ru = getParam("ru")
                if (ru) {
                  root.$store.dispatch("redirectOut", ru)
                } else {
                  // eslint-disable-next-line no-undef
                  wx.miniProgram.navigateBack({
                    delta: 1
                  })
                }
              } else {
                if (props.behavior === "show_bag_subject" && props.goodsId) {
                  root.$router.push({
                    path: `/detail/${props.currentItem.groupId}/biz/${props.currentItem.busId}/goods/${props.goodsId}`
                  })
                } else {
                  root.$router.go(-1)
                }
              }

              root.$store.dispatch("reportUserAction", {
                iformat: reportDict.CLICK.RESULT_FRIEND_RECOMMEND_SUCC_BACK
              })
            }
          }
        })

        emit("success")
        PromptWithIcon.show()

        root.$store.dispatch("reportUserAction", {
          iformat: reportDict.CLICK.RESULT_FRIEND_RECOMMEND_SUBMIT
        })
      }
    }

    /**
     * 评分弹窗提交评分
     */
    const submitRate = () => {
      if (state.dimensionList?.length > 0) {
        let ratedDimension = state.dimensionList.filter(dimension => {
          return dimension.score > 0
        })
        if (ratedDimension.length < state.dimensionList.length) {
          // 阻止评分，提示用户补充完整
          root.$store.dispatch("setToastMsg", "您的打分不完整哦，赶紧去补全吧~")
          return
        }
        // 提交评分
        const cb = () => {
          closePropRecomm()
          PromptWithIcon = root.$CallPromptWithIcon({
            title: "道具评分",
            iconStatus: true,
            mainMsg: "感谢您为我打分~",
            subMsg: "腾讯充值为您准备了评分礼物<br />请前往腾讯充值礼包中心领取哦~",
            cancelBtnInfo: {
              btnText: "前往礼包中心",
              callback() {
                goToTaskCenter()

                root.$store.dispatch("reportUserAction", {
                  iformat: reportDict.CLICK.RESULT_FRIEND_RECOMMEND_RATE_SUCC_CLICK,
                  resultInfo: getReportResultInfo()
                })
              }
            }
          })

          PromptWithIcon.show()

          root.$store.dispatch("reportUserAction", {
            iformat: reportDict.CLICK.RESULT_FRIEND_RECOMMEND_RATE_SUBMIT,
            resultInfo: getReportResultInfo()
          })
        }
        handleRateProps({ cb })
      }
    }

    /**
     * 引导用户去购物中心
     */
    const goToTaskCenter = () => {
      root.$router.push({
        path: `/taskCenter/${props.currentItem.groupId}/biz/${props.currentItem.busId}`,
        query: {
          pfStructure: "detail_star"
        }
      })
    }

    /**
     * 操作：推荐购买物品
     * 不推荐则不作任何操作
     */
    const handleBuyRecomm = async (subjectId, behavior = "") => {
      let sentence = ""
      if (state.selectedTags?.length > 0) {
        sentence = state.selectedTags.join("$$")
      }
      let res = await friendRecommObj.recommPropsAction({
        subject_id: subjectId,
        behavior: behavior || "show_buy",
        sentence: sentence,
        zoneParams: state.zoneParams
        // deleteSentence: true
      })

      return res
    }

    //   评分失败理论不影响种草的提交
    const handleRateProps = async ({ recomm = false, cb }) => {
      let dimension_score = state.dimensionList.map(item => `${item.dimension}:${parseInt(item.score)}`)

      let params = {
        subject_id: state.subjectId,
        subject_type: state.subjectType,
        dimension_score,
        score_factor: scoreFactor
      }

      // 判断是否有大区信息
      if (props.gameid) {
        params = {
          ...params,
          ...state.zoneParams
        }

        if (cb) root.$store.dispatch("setLoadingStart")

        let ratingRes = await starRatingObj.starRating(params)
        if (recomm) handleBuyRecomm(state.subjectId, "show_high_score")

        if (cb) {
          root.$store.dispatch("setLoadingEnd")
          if (ratingRes.ret !== 0) {
            let errMsg = ratingRes.err_code ? SYSTEM_BUSY : ratingRes.msg

            root.$store.dispatch("setToastMsg", errMsg)
            return
          }

          // 评星成功，且环比当前的评分弹窗
          cb()
        }
      }
    }

    /**
     * 关闭弹窗
     */
    const closePropRecomm = () => {
      state.showBuyRecommResult = false
    }

    /**
     * 展示弹窗
     */
    const showPropRecomm = () => {
      state.showBuyRecommResult = true
    }

    /**
     * 只去评分
     */
    const toggleRate = () => {
      state.showRatingDialog = !state.showRatingDialog

      root.$store.dispatch("reportUserAction", {
        iformat: state.showRatingDialog
          ? reportDict.CLICK.RESULT_FRIEND_RECOMMEND_CHANGE_RATE
          : reportDict.CLICK.RESULT_FRIEND_RECOMMEND_CHANGE_RECOMM
      })

      if (state.showRatingDialog)
        root.$store.dispatch("reportUserAction", {
          iformat: reportDict.PAGE_VIEW.RESULT_FRIEND_RECOMMEND_RATE,
          resultInfo: getReportResultInfo()
        })
    }

    const getReportResultInfo = () => {
      return {
        subjectType: state.subjectType,
        type: 0
      }
    }

    return {
      ...toRefs(state),
      scoreFactor,
      getCgiRes,
      recommBuyedProps,
      initRecommTags,
      initSentence,
      handleBuyRecomm,
      handleRateProps,
      goToTaskCenter,
      closePropRecomm,
      toggleRate,
      selectTag,
      selectRateScore,
      submitRate,
      STAR_REMARK,
      getReportResultInfo,
      showPropRecomm
    }
  }
}
</script>
